import React from 'react';
import Container from '@material-ui/core/Container';
import BokunLogo from '../../../assets/bokun-logo.svg';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { useStyles } from './css';

export const ValidateEmail = (): JSX.Element => {
    const classes = useStyles();

    return (
        <Container component="main" maxWidth="sm">
            <div className={classes.paper}>
                <img src={BokunLogo} className={classes.logo} alt={'Bokun'} />
                <Typography component="h1" variant="h5">
                    You've got mail{' '}
                    <span role="img" aria-label="mail">
                        📩
                    </span>
                </Typography>
                <Box style={{ marginTop: 40 }}>
                    <Typography>
                        Your sign up has been registered, but you will need to verify your e-mail
                        address before being able to log in.
                    </Typography>
                    <br />
                    <Typography>
                        We've sent you an e-mail containing a link to verify your e-mail address.
                        After verifying you will be able to log in to the Bókun Partners Portal and
                        create your first app!
                    </Typography>
                    <br />
                    <div
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <Button color={'primary'} href={'mailto:Inbox'}>
                            Open mail client
                        </Button>
                    </div>
                </Box>
            </div>
        </Container>
    );
};
